<template>
  <div class="carteira-vacinacao-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
      :on-close="onCancel"
    >
      <v-tabs v-model="tab">
        <v-tab>Documentos</v-tab>
        <v-tab>Certificados</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item class="mt-3">
          <field-group-form :group-label="'CNH'">
            <v-row>
              <v-col class="ma-0 py-0 pt-6" cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="cnhLink"
                  rules="size:20480"
                >
                  <v-file-input
                    v-model="fields.cnhLink"
                    chips
                    filled
                    prepend-icon="mdi-file-upload-outline"
                    :error-messages="errors"
                    :show-size="true"
                    :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                    :placeholder="$t('click_para_inserir_foto_pdf')"
                    accept="image/*, .pdf"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </field-group-form>
          <field-group-form :group-label="'RG/CPF'">
            <v-row>
              <v-col class="ma-0 py-0 pt-6" cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="rgCpfLink"
                  rules="size:20480"
                >
                  <v-file-input
                    v-model="fields.rgCpfLink"
                    chips
                    filled
                    prepend-icon="mdi-file-upload-outline"
                    :error-messages="errors"
                    :show-size="true"
                    :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                    :placeholder="$t('click_para_inserir_foto_pdf')"
                    accept="image/*, .pdf"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </field-group-form>
          <field-group-form :group-label="'CRACHA'">
            <v-row>
              <v-col class="ma-0 py-0 pt-6" cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="cartaoIdentLink"
                  rules="size:20480"
                >
                  <v-file-input
                    v-model="fields.cartaoIdentLink"
                    chips
                    filled
                    prepend-icon="mdi-file-upload-outline"
                    :error-messages="errors"
                    :show-size="true"
                    :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                    :placeholder="$t('click_para_inserir_foto_pdf')"
                    accept="image/*, .pdf"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </field-group-form>
          <field-group-form :group-label="'ASO'">
            <v-row>
              <v-col class="ma-0 py-0 pt-6" cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="asoLink"
                  rules="size:20480"
                >
                  <v-file-input
                    v-model="fields.asoLink"
                    chips
                    filled
                    prepend-icon="mdi-file-upload-outline"
                    :error-messages="errors"
                    :show-size="true"
                    :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                    :placeholder="$t('click_para_inserir_foto_pdf')"
                    accept="image/*, .pdf"
                  />
                </validation-provider>
              </v-col>
              <v-col class="ma-0 py-0 pt-2 pl-11" cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="asoDataExpiracao"
                  :rules="{ date: dateMask.rule }"
                >
                  <v-text-field
                    v-model="fields.asoDataExpiracao"
                    v-mask="dateMask.mask"
                    outlined
                    dense
                    background-color="white"
                    class="ma-0 pa-0"
                    :label="'Data Expiração'"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </field-group-form>
        </v-tab-item>

        <v-tab-item style="min-height: 360px">
          <v-layout justify-end class="mb-4 mt-1">
            <v-btn
              v-if="!showFormAddNewCertificate"
              color="success lighten-5 green--text text--darken-2"
              @click="showFormAddNewCertificate = true"
              x-small
              elevation="0"
              dark
            >
              <v-icon small>mdi-plus</v-icon>
              <small class="pl-1">novo certificado</small>
            </v-btn>
            <v-btn
              v-else
              text
              color="grey darken-1"
              @click="showFormAddNewCertificate = false"
              x-small
            >
              <v-icon small>mdi-close</v-icon>
              <small class="pl-1">fechar</small>
            </v-btn>
          </v-layout>
          <field-group-form
            v-if="showFormAddNewCertificate"
            :group-label="'Incluir um novo certificado'"
          >
            <v-row>
              <v-col class="ma-0 py-0 pt-6" cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="certificadoLink"
                  rules="size:20480"
                >
                  <v-file-input
                    v-model="novoCertificado.certificadoLink"
                    chips
                    filled
                    prepend-icon="mdi-file-upload-outline"
                    :error-messages="errors"
                    :show-size="true"
                    :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                    :placeholder="$t('click_para_inserir_foto_pdf')"
                    accept="image/*, .pdf"
                  />
                </validation-provider>
              </v-col>
              <v-col class="ma-0 py-0 pt-2 pl-11" cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="descricao"
                  :rules="{ required: tab === 1 }"
                >
                  <v-text-field
                    v-model="novoCertificado.descricao"
                    :required="tab === 1"
                    outlined
                    dense
                    background-color="white"
                    class="ma-0 pa-0"
                    :label="'Nome ou descrição'"
                    placeholder="ex. curso de matemática, curso de TI"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </field-group-form>
          <field-group-form
            v-show="!showFormAddNewCertificate"
            :group-label="'Todos os certificados'"
          >
            <v-row class="px-0 mx-0">
              <v-col v-if="data.certificados.length <= 0">
                <small class="grey--text text--darken-1">
                  <i>nenhum certificado encontrado</i>
                </small>
              </v-col>
              <v-col
                v-else
                v-for="(item, i) in data.certificados"
                :key="i"
                class="d-flex"
                cols="4"
              >
                <v-col cols="1" class="d-flex justify-center align-start">
                  <v-icon
                    size="36"
                    :color="
                      statusDeleteCertificate[i] === 1 ? 'grey lighten-1' : ''
                    "
                  >
                    mdi-file-certificate-outline
                  </v-icon>
                </v-col>
                <v-col class="ma-0">
                  <div
                    :class="{
                      'text-deleted': statusDeleteCertificate[i] === 1,
                    }"
                    style="font-size: 0.8rem"
                  >
                    {{ item.descricao | toPT_BRCapitalize }}
                  </div>
                  <div v-if="statusDeleteCertificate[i] === 1">
                    <v-progress-circular
                      indeterminate
                      size="12"
                      width="2"
                      color="primary"
                    />
                    <span class="pl-1 caption grey--text text--darken-2">
                      removendo
                    </span>
                  </div>
                  <div v-else class="d-flex flex-column">
                    <div class="pb-1">
                      <v-btn
                        link
                        tag="a"
                        target="_blank"
                        :href="
                          $store.state.attachmentDocumentURL +
                          'certificate/' +
                          item.certificadoLink
                        "
                        elevation="0"
                        x-small
                        color="blue lighten-1"
                        text
                        class="pa-0"
                      >
                        <v-icon size="13" class="mr-1">mdi-open-in-new</v-icon>
                        {{ $t("visualizar") }}
                      </v-btn>
                    </div>
                    <div>
                      <v-dialog
                        v-model="dialogConfirmDeleteCertificate[i]"
                        persistent
                        max-width="300px"
                      >
                        <template #activator="{ attr, on }">
                          <v-btn
                            v-on="on"
                            v-bind="attr"
                            text
                            x-small
                            color="red"
                            class="text-lowercase px-0"
                          >
                            <span
                              style="font-size: 24px; padding-right: 0.5rem"
                            >
                              &times;
                            </span>
                            remover
                          </v-btn>
                        </template>
                        <v-card max-width="300">
                          <v-card-title>Deletar?</v-card-title>
                          <v-card-text>
                            Deseja realmente excluir, depois de confirmar não
                            poderá reverter.
                          </v-card-text>
                          <v-card-actions>
                            <v-layout justify-space-between>
                              <v-btn
                                @click="onCloseConfirmDeleteCertificate(i)"
                                color="white"
                                small
                                dense
                              >
                                Não
                              </v-btn>
                              <v-btn
                                @click="onDeleteCertificate(i, item)"
                                color="red"
                                small
                                dense
                                dark
                              >
                                Sim
                              </v-btn>
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </div>
                </v-col>
              </v-col>
            </v-row>
          </field-group-form>
        </v-tab-item>
      </v-tabs-items>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { extend, ValidationProvider } from "vee-validate";
import { size, regex, required } from "vee-validate/dist/rules";
import { updateData, uploadFile } from "@/services";

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm, ValidationProvider },
  data() {
    return {
      tab: null,
      statusDeleteCertificate: [],
      showFormAddNewCertificate: false,
      dialogConfirmDeleteCertificate: [],
      fields: {
        cnhLink: null,
        rgCpfLink: null,
        cartaoIdentLink: null,
        asoLink: null,
        asoDataExpiracao: null,
      },
      novoCertificado: {
        certificadoLink: null,
        descricao: "",
      },
    };
  },
  watch: {
    "store.showModalDataForm"(nextValue) {
      if (nextValue) {
        this.fields.cnhLink = null;
        this.fields.rgCpfLink = null;
        this.fields.cartaoIdentLink = null;
        this.fields.asoLink = null;
        this.fields.asoDataExpiracao = this.data.asoDataExpiracao
          .split("T")[0]
          .split("-")
          .reverse()
          .join("/");
        this.novoCertificado = {
          certificadoLink: null,
          descricao: "",
        };
      }
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
    dateMask() {
      return this.$store.state.language === "en"
        ? { mask: "####-##-##", rule: /\d{4}-\d{2}-\d{2}/ }
        : { mask: "##/##/####", rule: /\d{2}\/\d{2}\/\d{4}/ };
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);

    extend("size", {
      ...size,
      message: this.$t("arquivo_menos_de_20MB"),
    });

    extend("date", {
      ...regex,
      message: this.$t("data_invalida"),
    });

    extend("required", {
      ...required,
      message: this.$t("obrigatorio"),
    });
  },
  methods: {
    onCloseConfirmDeleteCertificate(index) {
      const arr = Array();
      arr[index] = false;
      this.dialogConfirmDeleteCertificate = arr;
    },
    onDeleteCertificate(index, item) {
      this.onCloseConfirmDeleteCertificate(index);

      const arr = Array();
      arr[index] = 1;
      this.statusDeleteCertificate = arr;

      setTimeout(() => {
        this.$store.dispatch("tagFuncionario/deleteCertificado", {
          token: this.$store.state.auth.user.token,
          certificate: item,
          callbackSuccess: (certificate) => {
            this.data.certificados = this.data.certificados.filter(
              (e) => e !== certificate
            );
            this.statusDeleteCertificate = [];
          },
        });
      }, 1000);
    },
    onCancel(form) {
      form.reset();
    },
    onSave(s, form) {
      this.uploadCnh(this.data).then((data) =>
        this.uploadRgCpf(data).then((data) =>
          this.uploadCartaoIdent(data).then((data) =>
            this.updateASO(data).then((data) => {
              this.fields.cnhLink = data.cnhLink;
              this.fields.rgCpfLink = data.rgCpfLink;
              this.fields.cartaoIdentLink = data.cartaoIdentLink;
              this.fields.asoLink = data.asoLink;
              if (this.fields.asoDataExpiracao)
                this.fields.asoDataExpiracao = this.fields.asoDataExpiracao
                  .split("/")
                  .reverse()
                  .join("-");
              else this.fields.asoDataExpiracao = data.asoDataExpiracao;

              data = { ...data, ...this.fields };

              if (!this.novoCertificado.certificadoLink) {
                updateData(this, "tagFuncionario", data);
              } else {
                this.$store.commit("setSnackbarLoading", {
                  message: this.$t("Atualizando_aguarde"),
                  status: true,
                });
                this.$store.dispatch("tagFuncionario/uploadCertificado", {
                  token: this.$store.state.auth.user.token,
                  file: this.novoCertificado.certificadoLink,
                  data: {
                    funcionario: {
                      id: data.idFuncionario,
                    },
                    descricao: this.novoCertificado.descricao,
                  },
                  callbackSuccess: (certificate) => {
                    updateData(this, "tagFuncionario", data, () => {
                      this.data.certificados.push(certificate);
                      this.$store.commit("tagFuncionario/setData", this.data);
                    });
                  },
                });
              }

              form.reset();
            })
          )
        )
      );
    },
    uploadCnh(fields) {
      return new Promise((resolve) => {
        if (
          this.fields.cnhLink &&
          this.fields.cnhLink.constructor.name === "File"
        ) {
          uploadFile(
            this,
            "tagFuncionario",
            this.fields.cnhLink,
            "cnhLink",
            (data) => resolve({ ...fields, ...data })
          );
        } else {
          resolve(fields);
        }
      });
    },
    uploadRgCpf(fields) {
      return new Promise((resolve) => {
        if (
          this.fields.rgCpfLink &&
          this.fields.rgCpfLink.constructor.name === "File"
        ) {
          uploadFile(
            this,
            "tagFuncionario",
            this.fields.rgCpfLink,
            "rgCpfLink",
            (data) => resolve({ ...fields, ...data })
          );
        } else {
          resolve(fields);
        }
      });
    },
    uploadCartaoIdent(fields) {
      return new Promise((resolve) => {
        if (
          this.fields.cartaoIdentLink &&
          this.fields.cartaoIdentLink.constructor.name === "File"
        ) {
          uploadFile(
            this,
            "tagFuncionario",
            this.fields.cartaoIdentLink,
            "cartaoIdentLink",
            (data) => resolve({ ...fields, ...data })
          );
        } else {
          resolve(fields);
        }
      });
    },
    updateASO(fields) {
      return new Promise((resolve) => {
        if (
          this.fields.asoLink &&
          this.fields.asoLink.constructor.name === "File"
        ) {
          uploadFile(
            this,
            "tagFuncionario",
            this.fields.asoLink,
            "asoLink",
            (data) => resolve({ ...fields, ...data })
          );
        } else {
          resolve(fields);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.text-deleted {
  text-decoration: line-through;
  color: #888;
}
</style>
